export default function Footer() {
  return (
    <footer className='bg-gray-100 mt-20 shadow-inner'>
      <div className='max-w-7xl mx-auto px-4 py-10 grid grid-cols-1 md:grid-cols-3 gap-8  text-gray-600'>
        <div>
          <h3 className='text-sm font-semibold text-gray-800 mb-4'>ShadeUI</h3>
          <p className='text-gray-500'>
            Simple. Clean. Effective landing pages built with React and
            Tailwind.
          </p>
        </div>
        <div>
          <h4 className=' font-semibold text-gray-800 mb-2'>Quick Links</h4>
          <ul className='space-y-2'>
            <li>
              <a href='#features' className='hover:text-indigo-600 transition'>
                Features
              </a>
            </li>
            <li>
              <a href='#about' className='hover:text-indigo-600 transition'>
                About
              </a>
            </li>
            <li>
              <a href='#contact' className='hover:text-indigo-600 transition'>
                Contact
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h4 className=' font-semibold text-gray-800 mb-2'>Follow Us</h4>
          <ul className='flex space-x-4'>
            <li>
              <a
                href='https://github.com'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img
                  src='https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/github.svg'
                  alt='GitHub'
                  className='w-5 h-5'
                />
              </a>
            </li>
            <li>
              <a
                href='https://twitter.com'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img
                  src='https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/twitter.svg'
                  alt='Twitter'
                  className='w-5 h-5'
                />
              </a>
            </li>
            <li>
              <a
                href='https://linkedin.com'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img
                  src='https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/linkedin.svg'
                  alt='LinkedIn'
                  className='w-5 h-5'
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className='text-center py-4 text-gray-500 text-xs border-t'>
        © 2025 ShadeUI. All rights reserved.
      </div>
    </footer>
  )
}
